import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AnalysisService from "../../services/AnalysisService";

export const fetchAnalysisStatesReport = createAsyncThunk(
  "analysis/fetchAnalysisStatesReport",
  async (data) => {
    try {
      const res = await AnalysisService.getAnalyisStatesReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  analysisData: null,
};

const analysisSlice = createSlice({
  name: "analysis",
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Get Merchant Customer Interaction Report
    builder
      .addCase(fetchAnalysisStatesReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAnalysisStatesReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.analysisData = payload.data;
      })
      .addCase(fetchAnalysisStatesReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default analysisSlice.reducer;
